<template>
  <div>
    <br />
    <div class="row">
      <!-- <div class="col-sm-6 col-xs-12">
        <h2>Pass Data</h2>
        <pre>{{pass}}</pre>
      </div>
      <div class="col-sm-6 col-xs-12">
          <h2>Pass Metadata</h2>
          <pre>{{passMetadata}}</pre>
      </div>-->
      <!-- <div class="col-sm-6">
      <pre>{{passMetadata}}</pre>
    </div>
    <div class="col-sm-6">
    <pre>{{passMetadata.rows}}</pre>
      </div>-->
    </div>
    <h2
      v-if="
        filteredPassMetadata.rows &&
          filteredPassMetadata.rows.length > 0 &&
          filteredPassMetadata.rows[0].fields.length > 0
      "
    >
      {{ title }}
    </h2>
    <div class="row" v-for="row in filteredPassMetadata.rows" :key="row.id">
      <div
        :class="rowColumnSize(row)"
        v-for="field in row.fields"
        :key="field.name"
      >
        <Field
          :fieldMetadata="field"
          :value="pass[field.name]"
          @change="fieldUpdated"
          :error="getError(field.name)"
        />
        <div
          v-if="
            pass[field.name] && field.options && field.options[0].description
          "
        >
          <!-- <div class="card card-body bg-light">
          {{getOptionDescription(pass[field.name], field.options)}}
        </div> -->
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Field from "@/components/Shared/Field.vue";

export default {
  name: "PassInputFields",
  props: ["category", "title", "pass", "siteId", "errors", "passMetadata"],
  components: {
    Field
  },
  computed: {
    filteredPassMetadata() {
      //Only include fields that match the category set on the component
      if (!this.passMetadata.rows) {
        return this.passMetadata;
      }
      //Create copy to not alter the original
      let passMetadataCopy = JSON.parse(JSON.stringify(this.passMetadata));
      passMetadataCopy.rows.forEach(row => {
        row.fields = row.fields.filter(
          field => field.category === this.category || this.category === ""
        );
      });
      return passMetadataCopy;
    }
  },
  methods: {
    getError(fieldName) {
      if (
        typeof this.pass === "undefined" ||
        !this.errors ||
        !this.errors[fieldName]
      ) {
        return "";
      }

      return this.errors[fieldName];
    },
    fieldUpdated(field) {
      this.$emit("passUpdated", { name: field.name, value: field.value });
    },
    rowColumnSize(row) {
      if (row.fields.length > 1) {
        return "col-sm-6 col-xs-12";
      }
      return "col-sm-12 col-xs-12";
    },
    getOptionDescription(value, options) {
      let option = options.find(option => {
        if (option.name == value) {
          if (!option.description) {
            return false;
          }
          return true;
        }
      });
      return option.description;
    }
  }
};
</script>
